import styled from "styled-components";

import {
  whiteBgOnClickAnim,
  scaleOnClickAnim,
  boxInAnim,
  boxOutAnim,
  textClickAnim,
} from "../../animations";

export const Box = styled.div`
  padding: 30px;
  width: 375px;
  height: 667px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin: auto;
  animation: ${(p) => (p.aboveAnim ? boxInAnim : boxOutAnim)};
  animation-duration: ${(p) => (p.aboveAnim ? "0.33s" : "0.33s")};
  animation-fill-mode: forwards;
`;
export const Header = styled.div`
  /* font-size: 30px; */
  text-align: center;
  /* margin-top: 20%; */
  font-size: 36px;

  input {
    width: 100%;
    background: transparent;
    border: none;
    color: #ffb000;
    outline: none;
    font-size: 30px;
    text-align: center;
    ::placeholder {
      color: #ffb000;
    }
  }
  /* @media only screen and (min-width: 375px) {
    font-size: 36px;
  } */
`;
export const Button = styled.div`
  background: #ffb000;
  border: solid 3px #ffb000;
  border-radius: 38px;
  /* height: 48px; */
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  color: #ff3920;
  text-transform: uppercase;
  font-size: 20px;
  position: relative;
  cursor: pointer;
  :after {
    content: "";
    position: absolute;
    height: 100%;
    width: 100%;
    transform: scale(1);
    background: #ffffff;
    border: solid 3px #ffffff;
    border-radius: 38px;
    right: 50%;
    bottom: 50%;
    transform: translate(50%, 50%);
    width: 100%;
    height: 100%;
    opacity: 0;
    animation: ${(p) => (p.setA ? whiteBgOnClickAnim : null)};
    animation-duration: 0.5s;
  }
  animation: ${(p) => (p.setA ? scaleOnClickAnim : null)};
  animation-duration: 0.5s;
  @media only screen and (min-width: 375px) {
    height: 56px;
    /* margin-top: 130px; */
  }
`;

export const BackBtn = styled.div`
  font-size: 20px;
  color: #ffb000;
  text-transform: uppercase;
  text-align: center;
  margin-top: 24px;
  cursor: pointer;
  animation: ${(p) => (p.backA ? textClickAnim : null)};
  animation-duration: 0.5s;
`;

export const BtnGroup = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 20px auto;
`;
export const Btn = styled.div`
  /* width: 48px;
  height: 48px; */
  height: 56px;
  width: 56px;
  font-size: 20px;
  border-radius: 50%;
  border: solid 2.5px #ffb000;
  background: #ffb000;
  color: #ff3920;
  display: flex;
  align-items: center;
  justify-content: center;
  /* font-size: 18px; */
  text-transform: uppercase;
  position: relative;
  svg {
    /* height: 24px;
    width: 24px; */
    height: 28px;
    width: 28px;
  }
  :after {
    content: "";
    position: absolute;
    height: 100%;
    width: 100%;
    background: #ffffff;
    border: solid 3px #ffffff;
    border-radius: 38px;
    opacity: 0;
    right: 50%;
    bottom: 50%;
    transform: translate(50%, 50%);
    width: 100%;
    height: 100%;
    animation: ${(p) =>
      p.x2A || p.x5A || p.devA || p.plusA || p.minusA
        ? whiteBgOnClickAnim
        : null};
    animation-duration: 0.5s;
    ${(p) =>
      p.plusPress || p.minusPress
        ? "opacity: 0.5;  transition-timing-function: cubic-bezier(0, 0, 0.2, 1); trantision: opacity 0.25s;"
        : "opacity: 0;  transition-timing-function: cubic-bezier(0.7, 0.2, 0.3, 0); transition: opacity 0.25s"}
  }
  animation: ${(p) => (p.x2A || p.x5A || p.devA ? scaleOnClickAnim : null)};
  animation-duration: 0.5s;
  ${(p) =>
    p.plusPress || p.minusPress
      ? "transform: scale(0.65); transition-timing-function: cubic-bezier(0.33, 1, 0, 0); transition: transform 0.25s;"
      : "transform: scale(1); transition-timing-function: cubic-bezier(0.1, 0, 0, 1); transition: transform 0.25s;"};
  /* @media only screen and (min-width: 375px) {
    height: 56px;
    width: 56px;
    font-size: 20px;
    svg {
      height: 28px;
      width: 28px;
    }
  } */
`;
